import _defineProperty from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useLayoutEffect } from 'react';
import { transaction } from 'mobx';
// eslint-disable-next-line import/no-unresolved -- mobx-react-lite is a phantom dep provided by consuming apps
import { useObserver } from 'mobx-react-lite';
import _ from 'lodash';
import useStores from 'shared/hooks/use-stores';
import useApolloQuery from 'shared/hooks/use-apollo-query';
import getRewardsV2 from 'shared/graphql/reward/queries/get-rewards-V2.gql';
import isMobilePhone from 'validator/lib/isMobilePhone';
import { formatBirthdayForRewards, rewardsProgramEnabled } from 'shared/helpers/rewards';
// eslint-disable-next-line import/no-unresolved -- launchdarkly-react-client-sdk is a phantom dep provided by consuming apps
import { useFlags } from 'launchdarkly-react-client-sdk';
export default function useCheckForRewards(phoneParam, dobParam) {
  var _flags$posCustomers, _User$profile, _User$profile2, _Cart$order$dispensar, _Cart$order, _Cart$order$dispensar3, _Cart$order2, _Cart$rewardAuth, _data$getRewardsV;
  var _useStores = useStores(),
    User = _useStores.User,
    Cart = _useStores.Cart,
    UI = _useStores.UI;
  var flags = useFlags();
  var isSkipSMSSendingEnabled = (_flags$posCustomers = flags['pos.customers.skip-sms-sending.rollout']) !== null && _flags$posCustomers !== void 0 ? _flags$posCustomers : false;
  var phoneNumber = phoneParam || ((_User$profile = User.profile) === null || _User$profile === void 0 ? void 0 : _User$profile.phone) || '';
  var dob = formatBirthdayForRewards(dobParam || ((_User$profile2 = User.profile) === null || _User$profile2 === void 0 ? void 0 : _User$profile2.birthday) || '');
  var isAlpineIQEnabled = (_Cart$order$dispensar = (_Cart$order = Cart.order) === null || _Cart$order === void 0 || (_Cart$order = _Cart$order.dispensary) === null || _Cart$order === void 0 || (_Cart$order = _Cart$order.consumerDispensaryIntegrations) === null || _Cart$order === void 0 || (_Cart$order = _Cart$order.alpineiq) === null || _Cart$order === void 0 ? void 0 : _Cart$order.enabled) !== null && _Cart$order$dispensar !== void 0 ? _Cart$order$dispensar : false;
  var pin = Cart.rewardPin || (isSkipSMSSendingEnabled && isAlpineIQEnabled ? 'skip' : '');
  var dispensaryId = useObserver(function () {
    var _Cart$order$dispensar2;
    return (_Cart$order$dispensar2 = Cart.order.dispensary) === null || _Cart$order$dispensar2 === void 0 ? void 0 : _Cart$order$dispensar2.id;
  });
  var shouldSkipQuery = false;
  var birthdayRegex = new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/);
  var isValidBirthday = dob.match(birthdayRegex);
  var isDutchiePOSLoyaltyEnabled = (_Cart$order$dispensar3 = Cart.order.dispensary) === null || _Cart$order$dispensar3 === void 0 || (_Cart$order$dispensar3 = _Cart$order$dispensar3.consumerDispensaryIntegrations) === null || _Cart$order$dispensar3 === void 0 || (_Cart$order$dispensar3 = _Cart$order$dispensar3.dutchieposloyalty) === null || _Cart$order$dispensar3 === void 0 ? void 0 : _Cart$order$dispensar3.enabled;
  if (!rewardsProgramEnabled(Cart) && !isDutchiePOSLoyaltyEnabled) {
    shouldSkipQuery = true;
  } else if (!isMobilePhone(phoneNumber, 'en-US')) {
    shouldSkipQuery = true;
  } else if (UI.isVariant('kiosk')) {
    shouldSkipQuery = true;
  } else if (!Cart.order.dispensary.id) {
    shouldSkipQuery = true;
  } else if ((_Cart$order2 = Cart.order) !== null && _Cart$order2 !== void 0 && (_Cart$order2 = _Cart$order2.dispensary) !== null && _Cart$order2 !== void 0 && _Cart$order2.springbigEnabled && isValidBirthday === null) {
    shouldSkipQuery = true;
  } else if ((_Cart$rewardAuth = Cart.rewardAuth) !== null && _Cart$rewardAuth !== void 0 && _Cart$rewardAuth.authTextMessageSent) {
    shouldSkipQuery = true;
  } else if (User.exists && (!dob || dob === '--' || dob === 'Invalid date')) {
    shouldSkipQuery = true;
  }
  var customerId = User === null || User === void 0 ? void 0 : User.id;
  var skip = shouldSkipQuery || isDutchiePOSLoyaltyEnabled && !customerId;
  var _useApolloQuery = useApolloQuery(getRewardsV2, {
      phoneNumber: phoneNumber,
      dispensaryId: dispensaryId,
      dob: dob,
      pin: pin,
      customerId: customerId
    }, {
      fetchPolicy: 'no-cache',
      skip: skip
    }),
    data = _useApolloQuery.data,
    loading = _useApolloQuery.loading;

  // these changes cause a re-render, so we need to do them in an effect
  // since we do it in a layout effect, it happens synchronously and re-renders
  // that means there's no flicker, although render is called twice
  useLayoutEffect(function () {
    if (!loading && data !== null && data !== void 0 && data.getRewardsV2) {
      var auth = data.getRewardsV2.auth || {};
      if (Cart.rewardPin && !auth.pinConfirmed) {
        return;
      }
      transaction(function () {
        var _data$getRewardsV2$re;
        // stale rewards are cleared out by the cart automatically, so we don't want to do that here
        Cart.availableRewards = _.map((_data$getRewardsV2$re = data.getRewardsV2.rewards) !== null && _data$getRewardsV2$re !== void 0 ? _data$getRewardsV2$re : [], function (reward) {
          return _objectSpread(_objectSpread({}, reward), {}, {
            // provide reward brand for line item reference
            brand: data.getRewardsV2.rewardBrand
          });
        });
        Cart.hasRewardsWallet = data.getRewardsV2.userHasWallet;
        Cart.rewardsBalance = data.getRewardsV2.balance;
        Cart.rewardBrandName = data.getRewardsV2.rewardBrand;
        Cart.rewardAuth = data.getRewardsV2.auth || {};
        Cart.hasCheckedForRewards = true;
      });
    }
  }, [data === null || data === void 0 ? void 0 : data.getRewardsV2, loading, Cart]);
  return data === null || data === void 0 || (_data$getRewardsV = data.getRewardsV2) === null || _data$getRewardsV === void 0 ? void 0 : _data$getRewardsV.userHasWallet;
}